import {cloneDeep, pick} from 'lodash';
import {getArray, getBool, getString} from 'Core/helpers/data';
import {AclDataObject} from 'Core/acl/dataObjects';
import {
	acl_user_type_field_name,
	acl_permissions_field_name,
	acl_guest_flag_field_name,
	acl_field_names
} from 'Config/acl';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {AclDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);
	const additionalAclData = pick(result, getArray(acl_field_names.filter(fieldName => (
		fieldName !== acl_permissions_field_name &&
		fieldName !== acl_user_type_field_name &&
		fieldName !== acl_guest_flag_field_name
	))));

	result = new AclDataObject(
		getArray(result, acl_permissions_field_name),
		getString(result, acl_user_type_field_name),
		getBool(result, acl_guest_flag_field_name),
		additionalAclData,
	);

	return result;
}